import {Component, inject, InjectionToken, INJECTOR, Injector, input, OnDestroy} from "@angular/core";
import {IView} from "./IView";
import {IController, IT_CONTROLLER_OVERRIDES} from "../controllers/IController";
import {Subscription} from "rxjs";
import {ModelKey} from "../models/ModelKey";
import {Model} from "../models/Model";
import {ControllerEvent} from "../event-buses/ControllerEvent";

@Component({template: ''})
export abstract class AbstractView<ControllerType extends IController> implements IView<ControllerType>, OnDestroy {

  private readonly controller: ControllerType|undefined|null;

  private subscriptions: Array<Subscription> = [];

  protected constructor(defaultInjectionToken?: InjectionToken<ControllerType>) {
    const controllerToken = defaultInjectionToken;
    const injector: Injector = inject(INJECTOR);

    if(controllerToken) {
      const controllerOverrides: Array<any> = inject(IT_CONTROLLER_OVERRIDES, {optional: true});

      if(controllerOverrides && controllerOverrides.length > 0) {
        const matchingController = controllerOverrides.find((entry) => {
          if(entry['provide'] === controllerToken) {
            return true;
          }
          else {
            return false;
          }
        });

        if(matchingController) {
          if(matchingController['useClass']) {
            const childInjector = Injector.create({
              providers: [
                { provide: controllerToken, useClass: matchingController['useClass'] }
              ],
              parent: injector
            });

            this.controller = childInjector.get(controllerToken, null, {optional: false});
          }
          else if(matchingController['useFactory']) {
            const childInjector = Injector.create({
              providers: [
                { provide: controllerToken, useFactory: matchingController['useFactory'], deps: matchingController['deps'] },
              ],
              parent: injector
            });

            this.controller = childInjector.get(controllerToken, null, {optional: false});
          }
        }
      }

      if(!this.controller) {
        const hostProvidedController = inject(controllerToken, {optional: true, skipSelf: true});

        if(hostProvidedController) {
          this.controller = hostProvidedController;
        }
        else {
          this.controller = inject(controllerToken, {optional: true, self: true});
        }
      }
    }
  }

  getController(): ControllerType {
    if(this.controller) {
      return this.controller;
    }
    else {
      throw new Error('No controller available');
    }
  }

  protected getModel<T extends Model>(modelKey: ModelKey<T>): T {
    return this.getController().getModel(modelKey);
  }

  protected handle(eventName: string, eventData: any = {}): any {
    return this.getController().handle(eventName, eventData);
  }

  protected emit(event: ControllerEvent): void {
    this.getController().emit(event);
  }

  protected sub(subscription: Subscription): void {
    this.subscriptions.push(subscription);
  }

  ngOnDestroy() {
    if(this.subscriptions.length > 0) {
      this.subscriptions.forEach((s) => s.unsubscribe());
      this.subscriptions = [];
    }
  }

  protected trackGa(source: string) {
    // Deprecated. This will be removed later.
  }
}
